import { graphql } from '@repo/common/queries/helpers/server_query'

export const query_list_funds = graphql(`
  query query_list_funds {
    funds: feeders {
      id
      symbol
      price_per_share

      token_address
      minter {
        address
      }
      minter_history {
        address
        version
      }

      companies {
        name
        cms_name
      }
    }
  }
`)

export const query_list_simulated_funds = graphql(`
  query query_list_simulated_funds {
    simulated_funds {
      id
      symbol
      price_per_share

      companies {
        name
        cms_name
      }
    }
  }
`)

export const query_fund_daily_nav = graphql(`
  query query_fund_daily_nav($id: ID!) {
    fund_details: feeder_details(id: $id) {
      daily_nav {
        date
        nav_price_per_share: price_per_share
        round_price_per_share
      }
    }
  }
`)

export const query_simulated_fund_daily_nav = graphql(`
  query query_simulated_fund_daily_nav($id: ID!) {
    simulated_fund_details(id: $id) {
      daily_nav {
        date
        nav_price_per_share: price_per_share
        round_price_per_share
      }
    }
  }
`)

// Do we need this as a different query, if so price_per_share should probably be included
export const query_fund_company_value = graphql(`
  query query_fund_company_value($id: ID!) {
    fund_details: feeder_details(id: $id) {
      cash_balance
      companies {
        name
        cms_name
        value_held
      }
    }
  }
`)

export const query_simulated_fund_company_value = graphql(`
  query query_simulated_fund_company_value($id: ID!) {
    simulated_fund_details(id: $id) {
      cash_balance
      companies {
        name
        cms_name
        value_held
      }
    }
  }
`)
